export default "__VITE_ASSET__DZRT2Wyh__"